import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Box, CircularProgress } from '@mui/material';

import { CRM_LIST_DETAIL } from '../lists/lists.queries';
import { CampaignEditor } from './CampaignEditor';

/**
 * The campaign composer, for a campaign not made yet. Its first save makes it and moves to its
 * own page. Plan 4.4. `?to=` starts it going to that list or saved filter (from a list or a tag).
 */
export const CrmEmailCompose = () => {
  const [params] = useSearchParams();
  const to = Number(params.get('to'));
  const listId = Number.isInteger(to) && to > 0 ? to : null;
  const { data, loading } = useQuery<{ crmList: { id: number; name: string } | null }>(CRM_LIST_DETAIL, { variables: { id: listId }, skip: !listId });

  if (listId && loading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', py: 8 }}>
        <CircularProgress aria-label="Loading the list" />
      </Box>
    );
  }
  // A list that is gone, or could not be read, leaves the audience to choose.
  const audience = data?.crmList ? { id: data.crmList.id, name: data.crmList.name } : undefined;
  return <CampaignEditor key={audience?.id ?? 0} audience={audience} />;
};
